exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".accountsReceivable-example span {\n    font-weight: bold;\n}\n\n.rTable {\n    display: table;\n    width: 100%;\n}\n.rTableRow {\n    display: table-row;\n}\n.rTableHeading {\n    display: table-header-group;\n    background-color: #ddd;\n}\n.rTableCell, .rTableHead {\n    display: table-cell;\n    padding: 3px 10px;\n    border: 1px solid #999999;\n}\n.rTableHeading {\n    display: table-header-group;\n    background-color: #ddd;\n    font-weight: bold;\n}\n.rTableFoot {\n    display: table-footer-group;\n    font-weight: bold;\n    background-color: #ddd;\n}\n.rTableBody {\n    display: table-row-group;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./packages/custom/accounts-receivable/public/assets/css/accountsReceivable.css
// module id = 577
// module chunks = 0